import React, { useRef } from 'react';
import { RecordingHeaderWithRouteGuard } from './RecordingHeaderWithRouteGuard';
import { RecorderBody } from './RecorderBody';
import { RECORDING_STATUS } from './types';
import useRecorder from './useRecorder';
import VideoRecorderActions from './VideoRecorderActions';
import { isSafari } from '../../utils/browserCheck';
import { VideoPreviewReply } from './VideoPreviewReply';
import { IPlayerDesign } from 'queries/videoReply/types';

interface IRecordBothProps {
  screenStream: MediaStream;
  stopAllStreams: () => void;
  handleGoToRecordHome: () => void;
  showPreview?: boolean;
  onStartUpladingVoiceOverHandler?: (blob: Blob) => void;
  playerDesign: IPlayerDesign | undefined;
}

export const RecordBoth = ({
  screenStream,
  stopAllStreams,
  handleGoToRecordHome,
  showPreview = true,
  onStartUpladingVoiceOverHandler,
  playerDesign,
}: IRecordBothProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const {
    stopRecording,
    pauseRecording,
    startCountDown,
    stopCountDown,
    status,
    recordedBlob,
    countdown,
    timeInSeconds,
  } = useRecorder({
    screenStream,
    stopAllStreams,
    onStartUpladingVoiceOverHandler,
    videoRef,
    shouldStartCountdown: !isSafari,
    handleGoToRecordHome,
  });

  if (status === RECORDING_STATUS.DONE && recordedBlob && showPreview) {
    return (
      <VideoPreviewReply
        videoBlob={recordedBlob}
        handleGoToRecordHome={handleGoToRecordHome}
        playerDesign={playerDesign}
      />
    );
  }

  return (
    <>
      <RecordingHeaderWithRouteGuard
        status={status}
        handleGoToRecordHome={handleGoToRecordHome}
      />
      <RecorderBody videoRef={videoRef} countdown={countdown} status={status} />
      <VideoRecorderActions
        startCountDown={startCountDown}
        stopCountDown={stopCountDown}
        pauseRecording={pauseRecording}
        stopRecording={stopRecording}
        status={status}
        timeInSeconds={timeInSeconds}
        showVirtualBackgrounds={false}
      />
    </>
  );
};
